import { gql } from "@apollo/client";

import { propertyFragment } from "src/graphql/anti-fraud/fragments/PropertyFragment";

export const blacklistFragment = gql`
  fragment BlacklistFragment on Blacklist {
    name
    code
    properties {
      ...PropertyFragment
    }
    identifier {
      name
      code
      sourceProperties {
        ...PropertyFragment
      }
    }
  }

  ${propertyFragment}
`;
